export enum SortingDirectionType {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING',
}
